<template>
  <b-form-group :label="label">
    <v-select
        :class="{'v-select-danger': danger}"
        :state="danger ? false : null"
        :data-vv-as="label.toLowerCase()"
        :name="name"
        :placeholder="placeholder"
        :options="listOptions"
        :value="optionSelected"
        :disabled="isDisabled"
        :clearable="isClearable"
        @input="onInput"
    >
      <template #spinner>
        <b-spinner
            small
            v-if="categoryRegions.loading"
            variant="primary"
        />
      </template>
      <span slot="no-options">No hay regiones para el criterio de búsqueda</span>
    </v-select>
    <vs-icon
        v-if="!isClearable"
        class="ml-2 mt-5 pt-1 cursor-pointer"
        icon="remove_circle_outline"
        size="small"
        v-tooltip="'Eliminar selección'"
        color="danger"
        @click="clearSanitary"
    />
    <div
        v-if="danger"
        class="con-text-validation span-text-validation-danger v-enter-to"
        style="height: 19px;">
          <span class="span-text-validation">
            {{ dangerText }}
          </span>
    </div>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RegionsList',
  computed: {
    ...mapGetters('Herramientas', ['categoryRegions']),
    optionSelected() {
      const list = this.categoryRegions.map((region) => ({ ...region, label: region.descripcion }));
      return list.find((region) => region.descripcion === this.value) || '';
    },
    isDisabled() {
      return this.disabled
          || !this.categoryRegions.length;
    },
    listOptions() {
      return this.categoryRegions.map((region) => ({ ...region, label: region.descripcion }));
    }
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
    ]),
    onInput(event) {
      this.$emit('input', event?.descripcion);
    },
    getOption() {
      return this.categoryRegions.find((region) => region.descripcion === this.value);
    }
  },
  created() {
    this.listCategories({
      grupoOpcion: 'tipos.regiones-ed',
      deshabilitado: 'si'
    });
  },
  props: {
    name: { type: String, required: true },
    placeholder: { type: String, default: 'Busque por nombre' },
    label: { type: String, default: 'Región' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    clearSanitary: { type: Function, default: () => {} },
    withEmail: { type: Boolean, default: false }
  }
};

</script>
